import { enUS } from 'date-fns/locale';
import {
  formatRelative,
  differenceInHours,
  format,
  formatDistanceToNow,
  getDate,
  getMonth,
  getYear,
  isValid,
} from 'date-fns';
import { FreeformMessage, Message } from '../../generated/graphql';

const formatRelativeLocale: Record<string, string> = {
  lastWeek: 'EEEE, LLLL d, y',
  yesterday: "'yesterday'",
  today: "'today'",
  tomorrow: "'tomorrow'",
  thisWeek: 'EEEE, LLLL d, y',
  other: 'EEEE, LLLL d, y', // Difference: Add time to the date
};

const locale = {
  ...enUS,
  formatRelative: (token: string) => formatRelativeLocale[token],
};

export const formatRelativeForDateDivider = (date: Parameters<typeof formatRelative>[0]) =>
  formatRelative(date, new Date(), { locale });

export function isFreeFormMessage(message: Message): message is FreeformMessage {
  return (<FreeformMessage>message).__typename === 'FreeformMessage';
}

export function freeFormMessage(message: Message) {
  if (isFreeFormMessage(message)) {
    return message;
  } else {
    return null;
  }
}

export const sentAt = (dateString?: string | null) => {
  if (dateString && isValid(new Date(dateString))) {
    const date = new Date(dateString);
    if (differenceInHours(date, new Date()) > 1) {
      return formatDistanceToNow(date, { addSuffix: true });
    } else {
      return format(date, 'p');
    }
  } else {
    return '';
  }
};

export const groupMessagesByDate = (messages: FreeformMessage[] = []) => {
  const sortedMessages = messages.sort(({ createdAt: cA1 }, { createdAt: cA2 }) => cA1.localeCompare(cA2));

  const map = new Map<string, FreeformMessage[]>();
  for (const message of sortedMessages) {
    if (!isValid(new Date(message.createdAt))) continue;
    const createdAt = new Date(message.createdAt);
    const createdAtSimple = new Date(getYear(createdAt), getMonth(createdAt), getDate(createdAt)).toISOString();
    const entries = map.get(createdAtSimple);
    if (!entries) {
      map.set(createdAtSimple, [message]);
    } else {
      map.set(createdAtSimple, [...entries, message]);
    }
  }

  return Array.from(map);
};
